import React from 'react';
import Page from '../Page';
import $ from 'jquery';
import { Row, Col } from 'react-materialize';
import { Link } from "react-router-dom";
import queryString from 'query-string';
import { CheckAuth } from '../Util';
import { API_BASE_URL } from '../Util';
import { notify } from 'react-notify-toast';
import { Redirect } from 'react-router-dom';

class CallbackPrakerja extends Page {
  constructor(props) {
    super(props);
    this.state = {
      loading: true, // New state variable
      apiCompleted: false,
      sequence: null,
      content:'',
      contentDestination:'',
      callbackData: {
        state: undefined,
        error: undefined,
        error_code: undefined,
        error_description: undefined,
      },
    };
  }

  componentDidMount() {
    this.handleLoadData();
    //this.startRedirectTimeout();
  }

  handleLoadData() {
    const API_CALLBACK = API_BASE_URL + '/callback';

    // Parse error query parameters from the URL
    const parsedQuery = queryString.parse(this.props.location.search);

    this.setState(
      {
        callbackData: {
          state: parsedQuery.state,
          error: parsedQuery.error,
          error_code: parsedQuery.error_code,
          error_description: parsedQuery.error_description,
        },
      },
       async () => { 
        // Callback function to ensure that the state is updated
        const { state, error, error_code, error_description } = this.state.callbackData;
        
        //if no state just throw
        if (!state) {
          return;
        }

        if (error !== undefined) {
          notify.show(error, 'warning');
          await $.post(API_CALLBACK, { state, error, error_code, error_description }).then((data) => {
            // Handle the response data if needed
            this.setState({ apiCompleted: true, loading: false, sequence: data.sequence }); // Set apiCompleted to true and loading to false after API call is done
          });
        } else {
          // if (this.isLogin()) {
            notify.show('Anda telah berhasil verifikasi wajah.', 'success');
            await $.post(API_CALLBACK, { state }).then((data) => {
              // Handle the response data if needed
              this.setState({ apiCompleted: true, loading: false, sequence: data.sequence }); // Set apiCompleted to true and loading to false after API call is done
          });
          // }
        }

        let content, contentDestination
        if(this.isLogin()){
          content = <Link className="btn" to={{ pathname: '/profile', isFromCallback: true }}>Halaman Kelas Saya</Link>
          contentDestination = <span>ke <b>Kelas Saya</b> lalu klik <b>Status Kode Redeem</b></span>
          this.setState({content, contentDestination})
        }else{
          content = <Link className="btn" to="/login">Login</Link>
          contentDestination = <span>untuk Login dan menuju halaman <b>Kelas Saya</b> lalu klik <b>Status Kode Redeem</b></span>
          this.setState({content, contentDestination})
        }
      }
    );
  }

  // Check if the user is logged in
  isLogin() {
    return CheckAuth() !== false;
  }

  startRedirectTimeout() {
    setTimeout(() => {
      //this.setState({ shouldRedirect: true });
    }, 1000);
  }

  render() {
    const { error, error_description } = this.state.callbackData;
    const content = error ? (
      <div>
        <p>{error_description}. <br/>Silakan lanjutkan {this.state.contentDestination}</p>
        {this.state.content}
      </div>
    ) : (
      <div>
        <p>Selamat Kelas Kamu sudah aktif.<br/>Silakan lanjutkan {this.state.contentDestination}</p>
        {this.state.content}
      </div>
    );
    // this.setState({content})

    // Render based on conditions
    if (this.state.loading) {
      return <p className='text-center'>Loading...</p>;
    }

    return (
      <div className="pb-m border-bottom">
        <Row className="container valign-wrapper">
          <Col className="pad-m bg-white" s={12}>
            <div>
              <b>Halo, Greeners !</b>
            </div>
            {content}
          </Col>
        </Row>
      </div>
    );
  }
}

export default CallbackPrakerja;



// WEBPACK FOOTER //
// ./src/components/Public/CallbackPrakerja.js